import { Card, CardContent } from "@/components/ui/card";
const HowItWorks = () => {
  return <section className="space-y-8">
      <div className="text-center max-w-xl mx-auto space-y-2">
        <h2 className="text-3xl font-bold">Como funciona</h2>
        <p className="text-muted-foreground">Transforme sua jornada de saúde mental em poucos passos simples</p>
      </div>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
        <Card className="border-none shadow-soft bg-background/50">
          <CardContent className="p-6 flex flex-col items-center text-center space-y-4">
            <div className="bg-primary/10 rounded-full w-16 h-16 flex items-center justify-center">
              <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z" />
              </svg>
            </div>
            <h3 className="text-xl font-medium">Crie sua conta</h3>
            <p className="text-muted-foreground">
              Cadastre-se gratuitamente e preencha seu perfil para começar sua jornada.
            </p>
          </CardContent>
        </Card>

        <Card className="border-none shadow-soft bg-background/50">
          <CardContent className="p-6 flex flex-col items-center text-center space-y-4">
            <div className="bg-primary/10 rounded-full w-16 h-16 flex items-center justify-center">
              <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 className="text-xl font-medium">Agende sua consulta</h3>
            <p className="text-muted-foreground">
              Escolha o horário que melhor se adapta à sua rotina e agende em poucos cliques.
            </p>
          </CardContent>
        </Card>

        <Card className="border-none shadow-soft bg-background/50">
          <CardContent className="p-6 flex flex-col items-center text-center space-y-4">
            <div className="bg-primary/10 rounded-full w-16 h-16 flex items-center justify-center">
              <svg className="w-8 h-8 text-primary" fill="none" stroke="currentColor" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M15 10l4.553-2.276A1 1 0 0121 8.618v6.764a1 1 0 01-1.447.894L15 14M5 18h8a2 2 0 002-2V8a2 2 0 00-2-2H5a2 2 0 00-2 2v8a2 2 0 002 2z" />
              </svg>
            </div>
            <h3 className="text-xl font-medium">Conecte-se online</h3>
            <p className="text-muted-foreground">
              Participe da consulta via Google Meet de qualquer lugar, com toda privacidade.
            </p>
          </CardContent>
        </Card>
      </div>
    </section>;
};
export default HowItWorks;